import { createAction } from 'typesafe-actions'

import { CitiesActionTypes, CitiesState } from './types'

export const getCities = createAction(CitiesActionTypes.GET_CITIES, action => {
  return ({ name }: { name: string }) => action({ name })
})

export const getCitiesSuccess = createAction(
  CitiesActionTypes.GET_CITIES_SUCCESS,
  action => {
    return ({ list }: Pick<CitiesState, 'list'>) => action({ list })
  }
)

export const getCitiesFailure = createAction(
  CitiesActionTypes.GET_CITIES_FAILURE,
  action => {
    return () => action()
  }
)
